var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BrowserTemplate', [_c('v-row', [_c('v-col', {
    attrs: {
      "align-self": "center",
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "upload-yours-cover-area-wrapper"
  }, [_c('FileUploadArea', {
    attrs: {
      "vertical": "",
      "max-file-size": 10,
      "max-files-count": 1,
      "accept-mime": ['image/jpeg', 'image/png']
    },
    on: {
      "input": _vm.inputCover
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("Drop Image or choose file...")];
      },
      proxy: true
    }, {
      key: "subheader",
      fn: function () {
        return [_vm._v("Max size 10mb")];
      },
      proxy: true
    }])
  })], 1)]), _vm._l(_vm.uploadedCoversList, function (image, index) {
    return _c('v-col', {
      key: image.url ? image.url.toLocaleString() : index,
      attrs: {
        "align-self": "center",
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref) {
          var hover = _ref.hover;
          return [_c('v-img', {
            staticClass: "rounded-lg result-image",
            class: _vm.activeImage === image.url && 'active',
            attrs: {
              "width": "288px",
              "height": "162px",
              "src": image.url
            },
            on: {
              "load": function ($event) {
                image.loaded = true;
              },
              "click": function ($event) {
                return _vm.setActiveImage(image);
              }
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function () {
                return [_c('v-scale-transition', {
                  attrs: {
                    "origin": "center"
                  }
                }, [hover && image.loaded ? _c('v-btn', {
                  staticClass: "image-floating-remove-button v-btn--error",
                  attrs: {
                    "icon": "",
                    "small": ""
                  },
                  on: {
                    "click": function ($event) {
                      $event.stopPropagation();
                      return _vm.removeCover(index);
                    }
                  }
                }, [_c('TrashIcon', {
                  attrs: {
                    "size": "18"
                  }
                })], 1) : _vm._e()], 1)];
              },
              proxy: true
            }, {
              key: "placeholder",
              fn: function () {
                return [_c('v-row', {
                  staticClass: "fill-height ma-0",
                  attrs: {
                    "align": "center",
                    "justify": "center"
                  }
                }, [_c('f-circle-loader', {
                  attrs: {
                    "size": "5"
                  }
                })], 1)];
              },
              proxy: true
            }], null, true)
          })];
        }
      }], null, true)
    })], 1);
  })], 2), _c('v-dialog', {
    attrs: {
      "max-width": _vm.$vuetify.breakpoint.mobile ? '100%' : '900px',
      "fullscreen": _vm.$vuetify.breakpoint.mobile,
      "persistent": ""
    },
    model: {
      value: _vm.showCropper,
      callback: function ($$v) {
        _vm.showCropper = $$v;
      },
      expression: "showCropper"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', [_vm._v("Crop image for header")]), _c('v-spacer'), _c('span', {
    staticClass: "caption text--secondary"
  }, [_vm._v("Adjust the area to look perfect in your form")])], 1), _c('v-card-text', [_vm.cropperImage ? _c('vue-cropper', {
    ref: "pictureCropper",
    style: ("width:100%;height:" + (_vm.$vuetify.breakpoint.mobile ? '300px' : '500px') + ";"),
    attrs: {
      "src": _vm.cropperImage,
      "aspect-ratio": _vm.aspectRatio,
      "view-mode": 1,
      "auto-crop-area": 1,
      "guides": true,
      "center": true,
      "highlight": true,
      "crop-box-movable": true,
      "crop-box-resizable": true,
      "toggle-drag-mode-on-dblclick": false
    }
  }) : _vm._e(), _c('div', {
    staticClass: "mt-3"
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v(_vm._s(_vm.dimensionsText))])])], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "gray_100",
      "rounded": "",
      "disabled": _vm.cropperLoading
    },
    on: {
      "click": _vm.cancelCrop
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "blue_400",
      "rounded": "",
      "loading": _vm.cropperLoading
    },
    on: {
      "click": _vm.confirmCrop
    }
  }, [_vm._v("Confirm Crop")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }